import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourReferenceApi } from '../api/labourReferenceApi'; 
import { RootState } from '..';

export interface LabourReferenceState {
  labourReferenceDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourReferenceState = {
  labourReferenceDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourReferenceSlice = createSlice({
  name: 'labourReference',
  initialState,
  reducers: {
    setReferenceDetails: (state, action: PayloadAction<any>) => {
      state.labourReferenceDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourReferenceApi.endpoints.createLabourReference.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourReferenceApi.endpoints.createLabourReference.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourReferenceDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourReferenceApi.endpoints.createLabourReference.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setReferenceDetails, setLoading, setError, reset } = labourReferenceSlice.actions;
export const getReferenceDetails = (state: RootState) => state.labour.data;
export const getReferenceDetailsTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourReferenceSlice.reducer;